import { isNil } from 'lodash';

import { abbrNum, convertRatio, getMetricValueInPercentage } from 'utils/helper/common';
import { getPriceRecommendationRange } from 'utils/helper/price';

export function getFormattedAmount(value?: number | null): string {
  return abbrNum(value, { decimal: 1 }) || 'n/a';
}

export function getCostPerXValue(value?: number | null): string {
  const realValue = Number(value);

  if (isNil(value) || isNaN(realValue)) {
    return 'n/a';
  }

  if (value === 0) {
    return '0€';
  }

  return `${realValue.toFixed(realValue < 0.1 ? 2 : 1)}€`;
}

export function getFormattedPriceReco(min: number, max: number): string {
  return getPriceRecommendationRange(min, max) || 'n/a';
}

export function getFormattedPercentageRate(
  value?: number | null,
  includeRatio: boolean | null = true
): string {
  const fallbackValue = 'n/a';
  if (isNil(value)) {
    return fallbackValue;
  }

  let ratio = value;

  if (includeRatio) {
    ratio = convertRatio(ratio);
  }

  if (value >= 0 && ratio === 0) {
    // if rounded ratio is zero, but actual value is above or equal 0 (e.g. 0.000001)
    return '<0.1%';
  }

  if (isNaN(ratio)) {
    return fallbackValue;
  }

  return getMetricValueInPercentage(ratio);
}

export function getFormattedAdsToContentRate(value?: number | null): string {
  const fallbackValue = 'n/a';
  if (isNil(value)) {
    return fallbackValue;
  }

  if (value === 0) {
    return '0%';
  }

  const ratio = convertRatio(value);
  if (value > 0 && ratio === 0) {
    // if rounded ratio is zero, but actual value is above 0 (e.g. 0.000001), real zero is shown as 0 (see above)
    return '<0.1%';
  }

  if (isNaN(ratio)) {
    return fallbackValue;
  }

  return `${ratio.toFixed(1)}%`;
}
